import React, { useEffect, useState, useRef } from "react";
import style from "css/landing.module.css";
import TechnologyItem from "./technologyItem";
import SpaceItem from "./spaceItem";
import DeviceItem from "./deviceItem";
import { useMediaQuery } from "react-responsive";

function Technology() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const technologyRef = useRef(null);
  const [isVisible, setVisible] = useState(false);
  const [selected, setSelected] = useState("solution");
  const solutionList = [
    {
      isActive: true,
      img: "img/landing/tech/all_place.png",
      title: "All Place",
      label: "스마트 워크 플랫폼",
      text: "회의실 예약 및 화상회의, 자율좌석제 지정까지 all Place와 함께 유연하고 효율적인 업무 환경을 경험해 보세요",
      color: "#0f151b",
      link: "smart-space/work/platform",
    },
    {
      isActive: true,
      img: "img/landing/tech/be_gate.png",
      title: "Be Gate",
      label: "사내 App과 Webex/Zoom 연동",
      text: "Cisco WebEx 및 Zoom과의 연동을 지원하는 Gateway 솔루션입니다. 고객의 기본 Application과 원활한 API 연동을 지원합니다.",
      color: "#fe9d12",
      link: "smart-solution/begate",
    },
    {
      isActive: true,
      img: "img/landing/tech/cms_manager.png",
      title: "CMS <span>Manager</span>",
      label: "구축형 화상회의(MCU) 관리 시스템",
      text: "Cisco의 CMS 및 Poly의 Private Connect의 운용 및 관리를 위해 최적화된 솔루션으로, 영상회의 서비스를 안정적으로 관리하고, 관리자에게 높은 편의성과 효율성을 제공합니다.",
      color: "#1e9ce4",
      link: "smart-solution/cmsmanager",
    },
    {
      isActive: true,
      img: "img/landing/tech/device_one.png",
      title: "DeviceOne",
      label: "스마트 강의장비 컨트롤 시스템",
      text: "강의실 내 모든 디지털 장비(프로젝터, 스마트 보드, 카메라, 마이크, 조명 등)를 하나의 인터페이스에서 통합적으로 제어할 수 있는 소프트웨어 프로그램 입니다.",
      color: "#5464f5",
      link: "smart-solution/deviceOne",
    },
    {
      isActive: false,
      img: "img/landing/tech/medilink.png",
      title: "MediLink",
      label: "원격 진료 / 원격 회진 솔루션",
      text: "고객의 기본 어플리케이션과 화상회의 플랫폼의 API연동을 통해 진료 대기실 및 예약 / 화상 진료가 가능한 솔루션 입니다.",
      color: "#022759",
      link: "smart-solution/mediLink",
    },
  ];
  const spaceList = [
    {
      isActive: true,
      img: "img/landing/tech/smart_work_space.png",
      img_m: "img/landing/tech/smart_work_space_m.png",
      title: "Smart Work Space",
      label: "스마트 워크 스페이스",
      link: "smart-space/work",
    },
    {
      isActive: true,
      img: "img/landing/tech/smart_classroom.png",
      img_m: "img/landing/tech/smart_classroom_m.png",
      title: "Smart Classroom",
      label: "스마트 강의실 & 교실",
      link: "smart-space/room",
    },
    {
      isActive: false,
      img: "img/landing/tech/smart_telehealth_system.png",
      img_m: "img/landing/tech/smart_telehealth_system_m.png",
      title: "Smart\nTelehealth System",
      label: "스마트 텔레헬스 시스템",
    },
  ];

  const deviceList = [
    {
      img: "img/landing/tech/neat_bar_2.png",
      img_m: "img/landing/tech/neat_bar_2_m.png",
      img_over: "img/landing/tech/neat_bar_2_over.png",
      title: "neat.bar Generation 2",
      link: "smart-device/neat/bar2",
    },
    {
      img: "img/landing/tech/neat_bar_pro.png",
      img_m: "img/landing/tech/neat_bar_pro_m.png",
      img_over: "img/landing/tech/neat_bar_pro_over.png",
      title: "neat.bar pro",
      link: "smart-device/neat/barPro",
    },
    {
      img: "img/landing/tech/neat_board_pro.png",
      img_m: "img/landing/tech/neat_board_pro_m.png",
      img_over: "img/landing/tech/neat_board_pro_over.png",
      title: "neat.board pro",
      link: "smart-device/neat/boardPro",
    },
    {
      img: "img/landing/tech/neat_board_50.png",
      img_m: "img/landing/tech/neat_board_50_m.png",
      img_over: "img/landing/tech/neat_board_50_over.png",
      title: "neat.board 50",
      link: "smart-device/neat/board50",
    },
    {
      img: "img/landing/tech/neat_frame.png",
      img_m: "img/landing/tech/neat_frame_m.png",
      img_over: "img/landing/tech/neat_frame_over.png",
      title: "neat.frame",
      link: "smart-device/neat/frame",
    },
    {
      img: "img/landing/tech/neat_center.png",
      img_m: "img/landing/tech/neat_center_m.png",
      img_over: "img/landing/tech/neat_center_over.png",
      title: "neat.center",
      link: "smart-device/neat/center",
    },
    {
      img: "img/landing/tech/neat_pad.png",
      img_m: "img/landing/tech/neat_pad_m.png",
      img_over: "img/landing/tech/neat_pad_over.png",
      title: "neat.pad",
      link: "smart-device/neat/pad",
    },
  ];

  const handleTabClick = (e) => {
    setSelected(e);
  };

  const tabContentsSwitch = (selected) => {
    switch (selected) {
      case "solution":
        return solutionList.map((solution, index) => (
          <TechnologyItem tech={solution} key={index} type={selected} />
        ));
      case "space":
        return spaceList.map((space, index) => (
          <SpaceItem tech={space} key={index} type={selected} />
        ));
      case "device":
        return !isMobile && !isTablet ? (
          <>
            <div className={style.technology_list_column_group}>
              {deviceList.slice(0, 2).map((device, index) => (
                <DeviceItem tech={device} key={index} type={selected} />
              ))}
            </div>
            {deviceList.slice(2).map((device, index) => (
              <DeviceItem tech={device} key={index} type={selected} />
            ))}
          </>
        ) : (
          <>
            {deviceList.map((device, index) => (
              <DeviceItem tech={device} key={index} type={selected} />
            ))}
          </>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting));
    });

    if (technologyRef.current) {
      observer.observe(technologyRef.current);
    }

    return () => {
      if (technologyRef.current) {
        observer.unobserve(technologyRef.current);
      }
    };
  }, []);
  return (
    <div className={style.technology_wrap} ref={technologyRef}>
      <div
        className={style.technology_text_wrap}
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible
            ? "translate3d(0, 0, 0)"
            : "translate3d(0, 50%, 0)",
          transition:
            "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
        }}
      >
        <div className={style.technology_title}>
          Riv<span>의</span> Technology
        </div>
        <div className={style.technology_text}>
          리브는 스마트하고 혁신적인 기술을 제공합니다.
        </div>
      </div>

      {!isMobile && !isTablet ? (
        <div
          className={style.technology_contents_area}
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible
              ? "translate3d(0, 0, 0)"
              : "translate3d(0, 50%, 0)",
            transition:
              "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
          }}
        >
          <div className={style.technology_tab}>
            <div
              className={
                selected === "solution"
                  ? style.technology_tab_item_active
                  : style.technology_tab_item
              }
              onClick={() => handleTabClick("solution")}
            >
              <span>Smart</span>
              <p>Solution</p>
            </div>
            <div
              className={
                selected === "space"
                  ? style.technology_tab_item_active
                  : style.technology_tab_item
              }
              onClick={() => handleTabClick("space")}
            >
              <span>Smart</span>
              <p>Space</p>
            </div>
            <div
              className={
                selected === "device"
                  ? style.technology_tab_item_active
                  : style.technology_tab_item
              }
              onClick={() => handleTabClick("device")}
            >
              <span>Smart</span>
              <p>Device</p>
            </div>
          </div>
          <div className={style.technology_card_list}>
            {tabContentsSwitch(selected)}
          </div>
        </div>
      ) : (
        <div className={style.technology_contents_area}>
          <div className={style.technology_list}>
            <div className={style.technology_list_label}>Smart Solution</div>
            <div className={style.technology_card_list}>
              {tabContentsSwitch("solution")}
            </div>
          </div>
          <div className={style.technology_list}>
            <div className={style.technology_list_label}>Smart Space</div>
            <div className={style.technology_card_list}>
              {tabContentsSwitch("space")}
            </div>
          </div>
          <div className={style.technology_list}>
            <div className={style.technology_list_label}>Smart Device</div>
            <div className={style.technology_card_grid}>
              {tabContentsSwitch("device")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Technology;
